import React from 'react'

type Props = React.SVGProps<SVGSVGElement>

export function TrueworkLogo(props: Props) {
  return (
    <svg width="145" height="24" viewBox="0 0 145 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_8198_21165)">
        <mask id="mask0_8198_21165" maskUnits="userSpaceOnUse" x="0" y="0" width="145" height="24">
          <path d="M144.598 0H0V23.9182H144.598V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_8198_21165)">
          <mask id="mask1_8198_21165" maskUnits="userSpaceOnUse" x="0" y="0" width="145" height="24">
            <path d="M144.598 0H0V23.9182H144.598V0Z" fill="white" />
          </mask>
          <g mask="url(#mask1_8198_21165)">
            <path
              d="M49.3621 5.50781H46.5408V8.3169H44.8103V10.9964H46.5408V16.5874C46.5408 18.2442 47.0593 19.5942 48.0423 20.4805C48.8436 21.1964 49.894 21.5714 51.1127 21.5714C51.3619 21.5714 51.6245 21.5578 51.8871 21.5237L52.217 21.4828V18.8237L51.8265 18.8442C50.9579 18.8919 50.3451 18.7351 49.9479 18.3533C49.5573 17.9783 49.3621 17.3578 49.3621 16.4987V10.9078H52.2237V8.22827H49.3621V5.50781Z"
              fill="#02322B"
            />
            <path
              d="M55.853 9.33443C54.7218 10.3708 54.1225 11.8776 54.1225 13.6981V21.5253H56.9438V13.6094C56.9438 12.6481 57.2131 11.9049 57.7518 11.4003C58.3645 10.8208 59.3207 10.5617 60.5327 10.6503L60.9299 10.6776V8.00489L60.6 7.9708C58.7214 7.77989 57.0313 8.25716 55.8597 9.33443"
              fill="#02322B"
            />
            <path
              d="M71.3195 16.3237C71.3195 17.1009 71.0232 17.8236 70.4845 18.3555C69.9189 18.9146 69.1513 19.2214 68.3231 19.1941C66.8485 19.16 65.65 17.8646 65.65 16.3032V8.23047H62.8287V16.1464C62.8287 19.5691 64.8757 21.785 68.0471 21.785C69.2927 21.785 70.4239 21.3827 71.3127 20.6464V21.5259H74.0465V8.23047H71.3127V16.3237H71.3195Z"
              fill="#02322B"
            />
            <path
              d="M89.4321 15.7305V15.3555C89.4321 10.501 85.9375 7.88281 82.6517 7.88281C78.9618 7.88281 75.9587 11.0055 75.9587 14.8305C75.9587 18.6555 78.9753 21.7851 82.82 21.7851C85.9308 21.7851 88.2336 20.1624 89.1426 17.3328H86.1463C85.4662 18.5805 84.3821 19.1805 82.9075 19.1055C81.2713 19.1055 79.4129 18.0487 79.0022 15.7305H89.4254H89.4321ZM79.1705 13.1396C79.7967 11.476 81.3925 10.5419 82.7392 10.4669C84.2744 10.4669 85.7019 11.5646 86.3011 13.1396H79.1705Z"
              fill="#02322B"
            />
            <path
              d="M104.973 8.23047L102.562 16.6441L100.158 8.23047H97.4313L95.0275 16.6441L92.6237 8.23047H89.6745L93.7145 21.5259H96.3473L98.7511 12.9623L101.155 21.5259H103.875L107.915 8.23047H104.973Z"
              fill="#02322B"
            />
            <path
              d="M114.877 7.88281C113.046 7.88281 111.356 8.5919 110.103 9.89418C108.824 11.2237 108.144 13.0169 108.184 14.926C108.184 16.7942 108.891 18.5396 110.171 19.8351C111.416 21.0965 113.093 21.7919 114.877 21.7919H114.898C116.668 21.7851 118.338 21.0624 119.604 19.7601C120.884 18.4374 121.597 16.6305 121.57 14.7965C121.51 10.8555 118.628 7.88963 114.877 7.88963M114.877 19.1124C112.703 19.1124 111.006 17.2374 111.006 14.8374C111.006 12.4374 112.743 10.4737 114.877 10.4737C117.012 10.4737 118.749 12.4305 118.749 14.8374C118.749 17.2442 117.012 19.1124 114.877 19.1124Z"
              fill="#02322B"
            />
            <path
              d="M125.2 9.33443C124.068 10.3708 123.469 11.8776 123.469 13.6981V21.5253H126.29V13.6094C126.29 12.6481 126.56 11.9049 127.098 11.4003C127.711 10.8208 128.667 10.5617 129.879 10.6503L130.277 10.6776V8.00489L129.947 7.9708C128.061 7.77989 126.378 8.25716 125.206 9.33443"
              fill="#02322B"
            />
            <path
              d="M139.097 13.3013L144.295 8.22855H140.201L135.003 13.3354V2.61719H132.182V21.4354H135.003V17.1876L136.996 15.2376L141.191 21.4354H144.605L139.097 13.3013Z"
              fill="#02322B"
            />
            <path
              d="M11.9722 0H5.91218C2.65325 0 0.00704956 2.67955 0.00704956 5.97955C0.00704956 9.27955 2.65325 11.9591 5.91218 11.9591H11.1574C11.5682 11.9591 11.8981 12.2932 11.8981 12.7091V17.8977C11.8981 21.225 14.5578 23.9182 17.8436 23.9182C21.1295 23.9182 23.7892 21.225 23.7892 17.8977V11.9591C23.7892 5.35227 18.5035 0 11.9789 0"
              fill="#02322B"
            />
            <path
              d="M36.0637 5.97955C36.0637 9.27955 33.4175 11.9591 30.1586 11.9591C26.8997 11.9591 24.2535 9.27955 24.2535 5.97955C24.2535 2.67955 26.8997 0 30.1586 0C33.4175 0 36.0637 2.67955 36.0637 5.97955Z"
              fill="#02322B"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_8198_21165">
          <rect width="144.598" height="23.9182" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
